<template>
    <Layout>
        <div slot="main" class="home-bg">
            <nav class="back-nav">
                <div class="center">
                    <div class="strong" v-if="!isPay">{{lang.service}} -- {{lang.productBuy}}</div>
                    <div class="strong" v-if="isPay">{{lang.service}} -- {{lang.productPay}}</div>
                    <div class="back-icon" @click="goBack">
                        <img :src="back" alt="">
                    </div>
                </div>
            </nav>
            <q-form ref="form" class="buy-block" v-show="!isPay">
                <h4 class="title-block">{{isCn?detail.productCnName:detail.productEnName}}</h4>
                <div class="buy-block">
                    <div class="center">
                        <div class="form-row" v-if="detail.isCountry">
                            <div class="form-item">
                                <p><strong>{{lang.buyCountry}} <i class="text-red">*</i></strong></p>
                                <p>
                                    <q-select
                                    outlined
                                    :readonly="checked"
                                    :filled="checked"
                                    v-model="country"
                                    :options="countrySelect"
                                    :option-value="opt => opt === null ? null : opt.id"
                                    :option-label="opt => opt === null ? '' : opt.name"
                                    :dense="true"
                                    :options-dense="true"
                                    @input="countryChange"
                                    :rules="[val => !!val || lang.inputBuyCountry]"></q-select>
                            </p>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-item">
                                <p><strong>{{lang.buyLastname}} <i class="text-red">*</i></strong></p>
                                <p><q-input
                                    outlined
                                    :readonly="checked"
                                    :filled="checked"
                                    v-model="lastname"
                                    :dense="true"
                                    maxlength="20"
                                    :rules="[val => !!val || lang.inputBuyLastname]"/></p>
                            </div>
                            <div class="form-item">
                                <p><strong>{{lang.buyFirstname}} <i class="text-red">*</i></strong></p>
                                <p><q-input
                                    outlined
                                    :readonly="checked"
                                    :filled="checked"
                                    v-model="firstname"
                                    :dense="true"
                                    maxlength="20"
                                    :rules="[val => !!val || lang.inputBuyFirstname]" /></p>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-item">
                                <p><strong>{{lang.buyCellphone}} <i class="text-red">*</i></strong></p>
                                <p>
                                    <q-input
                                        ref="cellphoneInput"
                                        outlined
                                        :readonly="checked"
                                        :filled="checked"
                                        v-model="cellphone"
                                        :dense="true"
                                        maxlength="20"
                                        :rules="[checkCountryCode, val => !!val || lang.inputBuyCellphone, val => reg.number.test(val) || lang.realBuyCellphone]" >
                                        <template v-slot:prepend>
                                            <input class="mini-input" v-model="countryCode" maxlength="10" :readonly="checked" @change="phoneCodeChange" />
                                        </template>
                                    </q-input>
                                </p>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-item">
                                <p><strong>{{lang.buyIdentity}} <i class="text-red">*</i></strong></p>
                                <p><q-input
                                    outlined
                                    :readonly="checked"
                                    :filled="checked"
                                    v-model="identity"
                                    :dense="true"
                                    maxlength="18"
                                    :rules="[val => !!val || lang.inputBuyIdentity, val => vali.judgeIdcard(val) || lang.realBuyIdentity]" /></p>
                            </div>
                            <div class="form-item">
                                <p><strong>{{lang.buyPassport}} <i class="text-red">*</i></strong></p>
                                <p><q-input
                                    outlined
                                    :readonly="checked"
                                    :filled="checked"
                                    v-model="passport"
                                    :dense="true"
                                    maxlength="30"
                                    :rules="[val => !!val || lang.inputBuyPassport, val => reg.normal.test(val) || lang.realBuyPassport]" /></p>
                            </div>
                        </div>
                        <div class="submit-row">
                            <span class="price-area">{{price===0?lang.customPrice:price}}</span>
                            <a class="btn-submit" @click="handleSubmit">{{checked?lang.buyConfirm:lang.buySubmit}}</a>
                        </div>
                    </div>
                </div>
            </q-form>
        </div>
    </layout>
</template>

<script>
import ajax from '@/utils/ajax';
import backSrc from '@/style/back.png';
import getLang from '@/utils/main/language';
import Layout from '@/views/Layout.vue';
import router from '@/router';
import regular from '@/utils/validate/regular';
import validate from '@/utils/validate';
import gNum from '@/utils/format/gNum';

export default {
    name: 'buy',
    components: {
        Layout,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            back: backSrc,
            lang: getLang(),
            isPay: false,
            reg: regular,
            vali: validate,
            countrySelect: [],
            price: null,
            country: {},
            lastname: '',
            firstname: '',
            countryCode: '+86',
            cellphone: '',
            identity: '',
            passport: '',
            checked: false,
            detail: {},
            orderId: 0,
        };
    },
    mounted() {
        const self = this;
        const { id } = this.$route.params;
        const productId = id.replace(/^CP0+/, '');
        this.productId = productId;
        ajax.get('/web/product/product_detail.json', { id: productId }).then((result) => {
            this.detail = result.data;
            this.countrySelect = result.data.countries.map((v) => {
                v.name = self.isCn ? v.countryCnName : v.countryEnName;
                return v;
            });
            this.price = result.data.isCountry === 0 ? `￥${gNum.numberToMoney(result.data.price)}` : null;
        }).catch(() => {
            this.$router.replace({ name: '404' });
        });
    },
    methods: {
        goBack() {
            if (this.checked) {
                this.checked = false;
            } else {
                router.go(-1);
            }
        },
        countryChange(val) {
            const self = this;
            this.countrySelect.forEach((v) => {
                if (v.id === val.id) {
                    self.price = v.price ? `￥${gNum.numberToMoney(v.price)}` : 0;
                }
            });
        },
        checkCountryCode() {
            if (!this.countryCode) {
                return this.lang.inputCountryCode;
            }
            if (!/^\+\d+/.test(this.countryCode)) {
                return this.lang.realCountryCode;
            }
            return true;
        },
        phoneCodeChange() {
            this.$refs.cellphoneInput.validate();
        },
        handleSubmit() {
            const self = this;
            this.$refs.form.validate().then((success) => {
                if (success) {
                    if (this.checked === false) {
                        this.checked = true;
                        window.scrollTop = 0;
                    } else {
                        ajax.post('/web/order/order_add.json', {
                            productId: this.productId,
                            countryCode: this.country.countryCode,
                            lastName: this.lastname,
                            firstName: this.firstname,
                            phoneCountryCode: this.countryCode,
                            phone: this.cellphone,
                            idCard: this.identity,
                            passPort: this.passport,
                        }).then((result) => {
                            router.push({ name: 'pay', params: { id: result.data } });
                        }).catch(() => {
                            self.$q.dialog({ title: this.lang.tips, message: this.lang.orderFail }).onDismiss(() => {
                                self.goBack();
                            });
                        });
                    }
                }
            });
        },
    },
};
</script>
<style lang="less" scoped>
    .home-bg {
        background: #F8FAF9;
    }
    .back-nav {
        width: 100%;
        height: 64px;
        background: #fff;
        display: flex;
        justify-content: space-between;
        align-content: center;
        border-bottom: 8px solid #F8FAF9;
        .center {
            width: 960px;
            margin: 0 auto;
            position: relative;
        }
        .back-icon {
            width: 11px;
            height: 16px;
            margin-top: 24px;
            margin-left: 2px;
            z-index: 3;
            cursor: pointer;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .strong {
            position: absolute;
            top: 0;
            left: 32px;
            width: 100%;
            height: 100%;
            font-size: 16px;
            color: #4A4A4A;
            line-height: 64px;
            font-weight: 500;
        }
    }
    .title-block {
        font-size: 20px;
        font-weight: 600;
        line-height: 24px;
        text-align: center;
    }
    .buy-block {
        margin-top: 12px;
        padding-bottom: 12px;
        .center {
            width: 960px;
            margin: 0 auto;
            padding-top: 12px;
            padding-bottom: 36px;
            background: #fff;
        }
        .form-row {
            display: flex;
            margin-left: 150px;
            .form-item {
                width: 300px;
                margin-right: 60px;
                strong {
                    font-weight: 600;
                    font-size: 14px;
                    line-height: 32px;
                }
                .mini-input {
                    width: 40px;
                    height: 16px;
                    line-height: 16px;
                    border-right: 1px solid #D1D3D1;
                    background: transparent;
                    color: #4A4A4A;
                    font-size: 14px;
                }
                input {
                    color: #9B9B9B;
                    font-size: 12px;
                }
            }
        }
        .submit-row {
            width: 660px;
            display: flex;
            justify-content: space-between;
            margin-left: 150px;
            margin-top: 24px;
            .price-area {
                font-size: 32px;
                line-height: 36px;
                font-weight: 600;
            }
            .btn-submit {
                color: #fff;
                background: #C71F4B;
                padding: 7px 28px;
                font-size: 16px;
                line-height: 22px;
                cursor: pointer;
            }
        }
    }
</style>
